import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { WinePackageModel, WinePackageWidgetModel } from '../../models/WinePackageWidgetModel';
import { WinePackage } from './WinePackage';
import { containerVariants, childVariants } from './animation/animation';

interface WinePackagesProps {
  item: WinePackageModel;
  winePackageList: WinePackageWidgetModel[];
}

/**
 * The FeaturedWinePackages component renders the featured wine packages.
 * @param item - The object containing information about the wine package.
 * @param winePackageList - The list of wine packages.
 * @returns The FeaturedWinePackages component is returning JSX elements.
 */

export const FeaturedWinePackages = ({ item, winePackageList }: WinePackagesProps) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  if (!winePackageList || winePackageList.length === 0) return <></>;

  const showEurPrice = winePackageList[0].showEurPrice;

  return (
    <motion.div ref={ref} variants={containerVariants} initial='hidden' animate={inView ? 'visible' : 'hidden'} className='flex gap-4 mb-2 w-full'>
      {item.renderedPackages > 0 && (
        <>
          {winePackageList.slice(0, Number(item.renderedPackages)).map((featurePackage: WinePackageWidgetModel, i: number) => (
            <motion.div key={i} variants={childVariants} className={`flex min-[350px]:w-[330px] lg:w-[370px] min-[350px]:h-[455px] md:h-[455px] ${showEurPrice ? 'lg:h-[390px]' : 'lg:h-[370px]'} p-0`}>
              <WinePackage key={i} winePackage={featurePackage} isShowCart={true} isShowContent={true} />
            </motion.div>
          ))}
        </>
      )}
    </motion.div>
  );
};
